export default __webpack_public_path__ + "static/media/background_gradient1.6d1866ac.png";